/* es6-iterator/get */ function _(require, module, exports) {
    var isArguments = require(326) /* es5-ext/function/is-arguments */, isString = require(363) /* es5-ext/string/is-string */, ArrayIterator = require(365) /* ./array */, StringIterator = require(370) /* ./string */, iterable = require(371) /* ./valid-iterable */, iteratorSymbol = require(384) /* es6-symbol */.iterator;
    module.exports = function (obj) {
        if (typeof iterable(obj)[iteratorSymbol] === "function")
            return obj[iteratorSymbol]();
        if (isArguments(obj))
            return new ArrayIterator(obj);
        if (isString(obj))
            return new StringIterator(obj);
        return new ArrayIterator(obj);
    };
}
